import React from 'react';
import { default as Form } from '../../components/connectedForm';
import Dropdown from '../../components/connectedForm/Dropdown';
import BlurTextField from '../../components/connectedForm/BlurTextField';
import { AlertType, ICustomerAlert, IProductAlert, ISupplierAlert } from '../../graphql/schema/p4types';
import fieldMetaData, { IEnumMetaData } from '../../graphql/schema/fieldMetaData';
import * as input from '../../components/connectedForm/inputComponents';
import { IDropdownProps } from '../../@types/dropdown';

type IAlertProps = { rowData: ICustomerAlert | ISupplierAlert | IProductAlert; rowIndex: number };

export const FormAlertRow = ({ rowData }: IAlertProps) => {
  return <div>{rowData?.title || 'New'}</div>;
};

export const FormAlertDetails = ({ rowIndex, type }: IAlertProps & { type: 'Customer' | 'Supplier' | 'Product' }) => {
  const baseDataid = `formAlerts.${rowIndex}`;

  return (
    <Form.Row>
      <Form.Fieldset cols={1 / 2}>
        <Form.Legend label={'Configuration'} />
        <Form.Field dataid={`${baseDataid}.title`} component={BlurTextField} label={'Title'} />
        <Form.Field<IDropdownProps>
          dataid={`${baseDataid}.alertType`}
          component={Dropdown}
          label={'Alert Type'}
          initialized={true}
          options={(fieldMetaData.AlertType as IEnumMetaData).enumValues.filter((enumValue) =>
            [AlertType.Info, AlertType.Warning].includes(enumValue.value as AlertType)
          )}
          enum={true}
          hint={"Select whether this should be an 'information' style or 'warning' style alert."}
        />
        <Form.Field<IDropdownProps>
          dataid={`${baseDataid}.alertPosition`}
          component={Dropdown}
          label={'Alert Position'}
          initialized={true}
          options={(fieldMetaData.AlertPosition as IEnumMetaData).enumValues}
          enum={true}
          hint={
            "Select where this alert will appear: 'default' (bottom-right notification), 'header' (displays above the form) or 'block' (prevents making changes until dismissed) style alert."
          }
        />
        <Form.Field dataid={`${baseDataid}.message`} component={BlurTextField} label={'Message'} />
        <Form.Field<IDropdownProps>
          dataid={`${baseDataid}.${type?.toLowerCase()}AlertForms`}
          component={Dropdown}
          label={'Forms'}
          multi={true}
          initialized={true}
          options={(fieldMetaData[`${type}AlertForm`] as IEnumMetaData).enumValues}
          enum={true}
          hint={'Choose which forms this alert should be displayed upon'}
        />
      </Form.Fieldset>
      <Form.Fieldset cols={1 / 2}>
        <Form.Legend label={'Delete'} />{' '}
        <Form.Field dataid={`${baseDataid}.deleted`} label={'Delete Alert '} component={input.Checkbox} />
      </Form.Fieldset>
    </Form.Row>
  );
};
